var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"episode-cameras"},[_vm._v(_vm._s(_vm.$tf('camera'))+": "+_vm._s(_vm.cameraNames))])}
var staticRenderFns = []

export { render, staticRenderFns }